document.addEventListener("DOMContentLoaded", function () {
  // EVENTS CLICKED BANNER HOME
  const banners = document.querySelectorAll(".slideshow__wrapper a");
  // Itera sobre los banners y agrega el evento de clic
  banners.forEach((banner, index) => {
    banner.addEventListener(
      "click",
      function (e) {
        e.preventDefault(); // Prevenir la acción predeterminada de seguir el enlace

        // Datos personalizados que quieres enviar
        const eventData = {
          bannerId: banner.id,
          bannerClasses: banner.className,
          bannerTagName: banner.tagName,
          bannerIndex: `Banner ${index + 1}`,
          bannerLink: banner.href,
        };

        console.log(eventData);

        // Publica el evento personalizado
        if (
          window.Shopify &&
          window.Shopify.analytics &&
          window.Shopify.analytics.publish
        ) {
          Shopify.analytics.publish("home_banner_clicked", eventData);
        }

        setTimeout(() => {
          window.location.href = banner.href;
        }, 100);
      },
      { once: true }
    ); // Asegura que el evento se registre solo una vez
  });
  // END EVENTS CLICKED BANNER HOME

  // EVENTS CLICKED GRIDS IMAGES
  const isMobile = window.matchMedia("(max-width: 760px)").matches;
  // Selecciona los banners por ID o clase
  const promoBlocks = document.querySelectorAll(
    isMobile
      ? ".promo-grid--inner .mobile a.promo-block--content"
      : ".promo-grid--inner .computer a"
  );
  // Itera sobre los banners y agrega el evento de clic
  promoBlocks.forEach((banner, index) => {
    banner.addEventListener(
      "click",
      function (e) {
        e.preventDefault(); // Prevenir la acción predeterminada de seguir el enlace

        // Datos personalizados que quieres enviar
        const eventData = {
          bannerId: banner.id,
          bannerClasses: banner.className,
          bannerTagName: banner.tagName,
          bannerIndex: `Banner ${index + 1}`,
          bannerLink: banner.href,
        };

        console.log(eventData);

        // Publica el evento personalizado
        if (
          window.Shopify &&
          window.Shopify.analytics &&
          window.Shopify.analytics.publish
        ) {
          Shopify.analytics.publish("promo_grid_click", eventData);
        }

        setTimeout(() => {
          window.location.href = banner.href;
        }, 100);
      },
      { once: true }
    ); // Asegura que el evento se registre solo una vez
  });
  // END EVENTS CLICKED GRIDS IMAGES

  // EVENTS SHARED PRODUCTS
  // Selecciona los botones de compartir
  const shareButtons = document.querySelectorAll(".share-buttons--button");

  if (shareButtons) {
    shareButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        // Prevenir la acción predeterminada de seguir el enlace
        e.preventDefault();

        // Determina el método de compartir basado en la clase del botón
        const shareMethod = button.classList.contains("share-buttons--facebook")
          ? "Facebook"
          : button.classList.contains("share-buttons--twitter")
          ? "Twitter"
          : button.classList.contains("share-buttons--linkedin")
          ? "LinkedIn"
          : button.classList.contains("share-buttons--pinterest")
          ? "Pinterest"
          : "No se encontro";

        // Obtén el SKU del producto
        const sku =
          document.querySelector(
            "section > article > div.product-main > div > div:nth-child(2) > div > span"
          ).innerText || "No se encontro";

        // Obtén el título del producto
        const productTitle =
          document.querySelector(
            "section > article > div.product-main > div > div:nth-child(1) > h1"
          ).innerText || "No se encontro";

        // Datos personalizados que quieres enviar
        const eventData = {
          method: shareMethod,
          content_type: productTitle,
          item_id: sku,
        };

        // Publica el evento personalizado
        if (
          window.Shopify &&
          window.Shopify.analytics &&
          window.Shopify.analytics.publish
        ) {
          Shopify.analytics.publish("share", eventData);
        }

        // Espera un momento y luego abre el enlace en una nueva pestaña
        setTimeout(() => {
          window.open(button.href, "_blank");
        }, 100);
      });
    });
  }
  // END EVENTS SHARED PRODUCTS

  // EVENTS CLICK ON NAVBAR
  // Selecciona los enlaces del navbar
  const navLinks = document.querySelectorAll(".navmenu-link");

  if (navLinks) {
    navLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        // Datos personalizados que quieres enviar
        const category =
          link.closest("li").getAttribute("data-navmenu-parent") ||
          link.closest("li").getAttribute("class").split(" ")[1];
        const linkText = link.innerText.trim();
        const linkHref = link.getAttribute("href");

        const eventData = {
          category: category,
          link_text: linkText,
          link_href: linkHref,
        };

        console.log(eventData);

        // Publica el evento personalizado
        if (
          window.Shopify &&
          window.Shopify.analytics &&
          window.Shopify.analytics.publish
        ) {
          Shopify.analytics.publish("nav_click", eventData);
        }

        // Espera un momento y luego abre el enlace en una nueva pestaña
        if (linkHref) {
          setTimeout(() => {
            window.location.href = linkHref;
          }, 100);
        }
      });
    });
  }
  // END EVENTS CLICK ON NAVBAR

  // SUBMIT DITRIBUITOR FORM
  const contactForm = document.getElementById("contact_form");
  const submitButton = contactForm?.querySelector("button[type='submit']");

  if (contactForm && submitButton) {
    submitButton.addEventListener("click", function (e) {
      // Prevenir el envío del formulario
      e.preventDefault();

      // Obtener los valores del formulario
      const contactName = document.getElementById("contact_name").value;
      const contactEmail = document.getElementById("contact_email").value;
      const contactPhone = document.getElementById("contact_phone").value;
      const contactCompanyName = document.getElementById("name_ferre").value;
      const contactAddress = document.getElementById("address").value;
      const contactBusinessType = document.getElementById("type-bussi").value;
      const contactInvestmentAmount = document.getElementById("amount").value;
      const contactMessage = document.getElementById("contact_message").value;

      // Empujar los datos al dataLayer
      const eventData = {
        contact_name: contactName,
        contact_email: contactEmail,
        contact_phone: contactPhone,
        contact_company_name: contactCompanyName,
        contact_address: contactAddress,
        contact_business_type: contactBusinessType,
        contact_investment_amount: contactInvestmentAmount,
        contact_message: contactMessage,
      };

      // Publica el evento personalizado
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        window.Shopify.analytics.publish
      ) {
        Shopify.analytics.publish("contact_distribuitor_b2b", eventData);
      }

      // Verificación para asegurarse de que los datos están en el dataLayer
      setTimeout(() => {
        // Aquí puedes quitar el comentario para enviar el formulario después de la verificación
        contactForm.submit();
      }, 200);
    });
  }
  // END SUBMIT DITRIBUITOR FORM

  // CLICK GRID PRODUCTS
  const sections = document.querySelectorAll(
    "section[data-featured-collection]"
  );
  if (sections) {
    sections.forEach((section) => {
      const sectionTitle =
        section.querySelector(".home-section--title").innerText.trim() ||
        "Unknown Section Title";
      const items = section.querySelectorAll(".home-section--content > li");
      items.forEach((item, index) => {
        const productLink = item?.querySelector("a[data-product-page-link]");
        const productUrl =
          item?.getAttribute("data-product-quickshop-url") ||
          "Unknown Product URL";
        const fullProductTitle =
          item?.getAttribute("data-product-title") || "Unknown Product Title";
        const productSKU =
          item?.getAttribute("data-product-sku") || "Unknown Product SKU";

        if (productLink) {
          productLink.addEventListener(
            "click",
            (e) => {
              e.preventDefault();
              const eventData = {
                index: index + 1,
                sectionTitle: sectionTitle,
                fullProductTitle: fullProductTitle,
                productUrl: productUrl,
                productSKU: productSKU,
              };

              // Publica el evento personalizado
              if (
                window.Shopify &&
                window.Shopify.analytics &&
                window.Shopify.analytics.publish
              ) {
                Shopify.analytics.publish("featured_products_grid", eventData);
              }

              // Espera un momento y luego abre el enlace
              setTimeout(() => {
                window.location.href = productUrl;
              }, 200);
            },
            { once: true }
          );
        }
      });
    });
  }
  // END CLICK GRID PRODUCTS

  // DYNAMIC CLICK CART
  const cartButton = document.querySelector(".site-header-cart--button");

  if (cartButton) {
    cartButton.addEventListener("click", () => {
      const eventData = {
        eventType: "click_cart_draw",
      };

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        window.Shopify.analytics.publish
      ) {
        Shopify.analytics.publish("click_draw_cart", eventData);
      }
    });
  }
  // END DYNAMIC CLICK CART

  // CLICK CARROUSEL PRODUCTS
  const carrouselSections = document.querySelectorAll(
    "section[data-featured-collection]"
  );
  if (carrouselSections) {
    carrouselSections.forEach((section) => {
      const sectionTitle =
        section.querySelector(".home-section--title").innerText.trim() ||
        "Unknown Section Title";
      const items = section.querySelectorAll(
        ".flickity-slider .productgrid--item"
      );
      if (items) {
        items.forEach((item, index) => {
          const productLink = item.querySelector("a.productitem--image-link");
          const productUrl =
            item.getAttribute("data-product-quickshop-url") ||
            "Unknown Product URL";
          const fullProductTitle =
            item.getAttribute("data-product-title") || "Unknown Product Title";
          const productSKU =
            item.getAttribute("data-product-sku") || "Unknown Product SKU";

          if (productLink) {
            productLink.addEventListener(
              "click",
              (e) => {
                e.preventDefault();
                const eventData = {
                  index: index + 1,
                  sectionTitle: sectionTitle,
                  fullProductTitle: fullProductTitle,
                  productUrl: productUrl,
                  productSKU: productSKU,
                };

                // Publica el evento personalizado
                if (
                  window.Shopify &&
                  window.Shopify.analytics &&
                  window.Shopify.analytics.publish
                ) {
                  Shopify.analytics.publish(
                    "carrousel_products_grid",
                    eventData
                  );
                }

                // Espera un momento y luego abre el enlace
                setTimeout(() => {
                  window.location.href = productUrl;
                }, 200);
              },
              { once: true }
            );
          }
        });
      }
    });
  }
  // END CLICK CARROUSEL PRODUCTS

  // CLICK IN WHATSAPP LINK

  // Selecciona todos los enlaces de WhatsApp
  const whatsappLinks = document.querySelectorAll(
    'a[href*="wa.me"], a[href*="api.whatsapp.com/send"]'
  );

  // Verifica si existen enlaces de WhatsApp en la página
  if (whatsappLinks.length > 0) {
    // Agrega un event listener a cada enlace
    whatsappLinks.forEach((link) => {
      link.addEventListener(
        "click",
        function (event) {
          // Previene la acción por defecto de seguir el enlace inmediatamente
          event.preventDefault();

          // Captura el enlace desde donde se hizo clic
          const linkHref = event.currentTarget.href;

          // Captura el enlace de la página actual
          const currentUrl = window.location.href;

          // Lógica para enviar datos a tu sistema de analítica
          console.log("Enlace de WhatsApp clicado:", linkHref);
          console.log("Página desde donde se hizo clic:", currentUrl);

          // Ejemplo: Envío a Google Analytics

          const eventData = {
            event_category: "WhatsApp Link",
            event_label: linkHref,
            originating_page: currentUrl, // Personaliza la clave según tus necesidades
          };

          // Publica el evento personalizado
          if (
            window.Shopify &&
            window.Shopify.analytics &&
            window.Shopify.analytics.publish
          ) {
            Shopify.analytics.publish("whatsapp_click", eventData);
          }

          // Espera un momento y luego abre el enlace en una nueva pestaña
          setTimeout(() => {
            window.open(linkHref, "_blank");
          }, 100);
        },
        { once: true }
      );
    });
  }

  // END CLICK IN WHATSAPP LINK

  // CLICK CROSS SELLING

  if (document.querySelector(".product--container")) {
    const checkProductsLoaded = setInterval(() => {
      const recommendedProducts =
        document.querySelectorAll(".productgrid--item");

      if (recommendedProducts.length > 0) {
        clearInterval(checkProductsLoaded); // Detén el intervalo una vez que se encuentren los productos

        // Itera sobre cada producto y agrega el evento de clic
        recommendedProducts.forEach((product, index) => {
          product.addEventListener(
            "click",
            function (e) {
              e.preventDefault(); // Previene la acción predeterminada de los enlaces

              // Obtiene la información del producto desde los atributos del elemento
              const productTitle =
                product?.getAttribute("data-product-title") ||
                "Título no disponible";
              const productSKU =
                product?.getAttribute("data-product-sku") ||
                "SKU no disponible";
              const productURL =
                product
                  ?.querySelector(".productitem--image-link")
                  ?.getAttribute("href") || "URL no disponible";
              const productPriceElement =
                product?.querySelector(".andes-money-amount__fraction") ||
                product?.querySelector(".price__current--min");

              // Crea un objeto con los datos del producto
              const productData = {
                position: index + 1,
                item_name: productTitle,
                product_url: productURL,
                item_id: productSKU,
              };

              // Publica el evento personalizado
              if (
                window.Shopify &&
                window.Shopify.analytics &&
                window.Shopify.analytics.publish
              ) {
                Shopify.analytics.publish(
                  "recommended_product_click",
                  productData
                );
              }

              // Espera un momento y luego abre el enlace
              setTimeout(() => {
                window.location.href = productUrl;
              }, 200);
            },
            { once: true }
          );
        });
      }
    }, 100); // Verifica cada 100 ms si los productos han sido cargados
  }

  // END CLICK CROSS SELLING

  // CLICK GOOGLE MAPS SUCURSAL

  // Usa setInterval para verificar la existencia de enlaces de Google Maps
  const checkInterval = setInterval(() => {
    const googleMapsLinks = document.querySelectorAll(
      'a[href*="maps.google.com/"]'
    );

    // Verifica si existen enlaces de Google Maps en la página
    if (googleMapsLinks.length > 0) {
      googleMapsLinks.forEach((link) => {
        link.addEventListener(
          "click",
          function (event) {
            // Previene la acción por defecto de seguir el enlace inmediatamente
            event.preventDefault();

            // Captura el enlace desde donde se hizo clic
            const linkHref = event.currentTarget.href;

            // Captura el enlace de la página actual
            const currentUrl = window.location.href;

            // Intenta encontrar el nombre de la sucursal asociado
            let branchName = "Desconocido";
            const branchNameElement = link
              .closest(".branch-container")
              ?.querySelector("h2");

            if (branchNameElement) {
              branchName = branchNameElement.innerText.trim();
            } else {
              // Alternativamente, busca un <h2> anterior en el DOM si no está en el mismo contenedor
              const previousH2 =
                link.parentElement?.previousElementSibling?.querySelector("h2");
              if (previousH2) {
                branchName = previousH2.innerText.trim();
              }
            }

            // Datos personalizados que quieres enviar
            const eventData = {
              event_label: linkHref,
              branch_name: branchName,
              originating_page: currentUrl, // Personaliza la clave según tus necesidades
            };

            // Publica el evento personalizado
            if (
              window.Shopify &&
              window.Shopify.analytics &&
              window.Shopify.analytics.publish
            ) {
              Shopify.analytics.publish("click_in_google_maps", eventData);
            }

            // Espera un momento y luego abre el enlace en una nueva pestaña
            setTimeout(() => {
              window.open(linkHref, "_blank");
            }, 200);
          },
          { once: true }
        );
      });

      clearInterval(checkInterval); // Detiene el setInterval una vez que se encuentran y manejan los enlaces
    }
  }, 500); // Verifica cada 500ms

  // END CLICK GOOGLE MAPS SUCURSAL

  // SUBMIT NEWSLETTER

  // Formulario del Modal
  const shadowHost = document.querySelector("#app-embed-container-297279");
  const shadowRoot = shadowHost?.shadowRoot;

  if (shadowRoot) {
    // Encuentra los elementos dentro del Shadow Root
    const emailInput = shadowRoot.querySelector("#email"); // Input del correo electrónico
    const modalSubmitButton = shadowRoot.querySelector('[type="submit"]'); // Botón de envío

    if (emailInput && modalSubmitButton) {
      // Maneja el evento de clic en el botón de envío
      modalSubmitButton.addEventListener("click", function (e) {
        e.preventDefault(); // Prevenir el envío del formulario

        // Obtén el valor del input
        const emailValue = emailInput.value;
        console.log("Valor del correo:", emailValue);

        // Empujar los datos al dataLayer
        const eventData = {
          form_location: "Modal",
          email_newsletter: emailValue,
        };

        // Publicar el evento en Shopify Analytics
        if (
          window.Shopify &&
          window.Shopify.analytics &&
          window.Shopify.analytics.publish
        ) {
          Shopify.analytics.publish("newsletter_submission", eventData);
          console.log("Evento publicado:", eventData);
        }

        // Enviar el formulario después de un retraso para asegurar la captura del evento
        setTimeout(() => {
          shadowRoot.querySelector('form[data-testid="form"]').submit();
        }, 500);
      });
    } else {
      console.error(
        "No se encontró el input o el botón de envío dentro del Shadow Root."
      );
    }
  } else {
    console.error("No se pudo acceder al Shadow Root.");
  }

  // Formulario del Footer
  const footerForm = document.querySelector("form.contact-form");
  const footerSubmitButton = footerForm?.querySelector("button[type='submit']");

  if (footerForm && footerSubmitButton) {
    footerSubmitButton.addEventListener("click", function (e) {
      // Prevenir el envío del formulario
      e.preventDefault();

      // Obtener el correo del formulario del Footer
      const footerEmail = footerForm.querySelector('input[type="email"]').value;

      // Empujar los datos al dataLayer
      const footerEventData = {
        form_location: "Footer",
        email_newsletter: footerEmail,
      };

      // Publicar el evento personalizado
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        window.Shopify.analytics.publish
      ) {
        Shopify.analytics.publish("newsletter_submission", footerEventData);
      }

      // Verificación y envío del formulario
      setTimeout(() => {
        footerForm.submit();
      }, 1000);
    });
  }

  // END SUBMIT NEWSLETTER
});
